export default {
    imageDashboardSummary: {
        totalImagesGenerated: 'Totaal aantal gegenereerde afbeeldingen',
        cost: 'Kosten',
        imagesPerDay: 'Afbeeldingen/dag',
    },
};
